export class UBSStruct {
    idUBSScreenConfig: number | null = null;
    idUBSScreen: number | null = null;
    screenDescription: string = '';
    screenUrl: string = '';
    order: number | null = null;
}